import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import ReduxLogger from "redux-logger";

import persistDataMiddleware from "./middleware/persistDataMiddleware";
import createLogger from "./utils/logger";
import rootReducer from "./rootReducer";
import rootWatchers from "./rootsaga";

const composeEnhancer =
    (process.env.NODE_ENV !== "production" && window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]) || compose;

const sagaMiddleware = createSagaMiddleware();
const middleware =
    process.env.NODE_ENV === "production"
        ? [sagaMiddleware, persistDataMiddleware]
        : [sagaMiddleware, persistDataMiddleware, ReduxLogger, createLogger(true)];
const store = createStore(rootReducer, composeEnhancer(applyMiddleware(...middleware)));
sagaMiddleware.run(rootWatchers);

export { store };
